import React from "react";
import Page from "../templates/support/childrin&education/spotlight/fare-spectra-school-of-autism";
import { Helmet } from "react-helmet";

export default function home() {
  return (
    <div>
      <Helmet>
        <title>Fare Spectra | School of Autism | Hirdaramani</title>
        <meta
          name="title"
          content="Fare Spectra | School of Autism | Hirdaramani"
        />
        <meta
          name="description"
          content="Supporting inclusive education for autistic children in Bangladesh, Hirdaramani partners with FARE, providing tech solutions for enhanced communication."
        />
        <link
          rel="canonical"
          href="https://sustainability.hirdaramani.com/support/children&education/spotlight-fare-spectra-school-of-autism/"
        />
        <meta property="og:locale" content="en_US" />
        {/* <meta name="keywords" content="" /> */}
        <meta
          property="og:title"
          content="Fare Spectra | School of Autism | Hirdaramani"
        />
        <meta
          property="og:description"
          content="Supporting inclusive education for autistic children in Bangladesh, Hirdaramani partners with FARE, providing tech solutions for enhanced communication."
        />
        <meta
          property="og:image"
          content="https://hirdaramani-microsite.sgp1.digitaloceanspaces.com/images/logo.png"
        />
        <meta
          property="og:url"
          content="https://sustainability.hirdaramani.com/support/children&education/spotlight-fare-spectra-school-of-autism/"
        />
      </Helmet>

      <Page />
    </div>
  );
}
